import { request, queryString } from '../util'

const headers = { 'Content-Type': 'application/json' }
const url = '/private/api/employees'

export default {
  add (values) {
    return request(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(values)
    })
  },
  get (id) {
    return request(`${url}/${id}`)
  },
  remove (id) {
    return request(`${url}/${id}`, {
      method: 'DELETE',
      headers
    })
  },
  save (id, values) {
    return request(`${url}/${id}`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  getEmployeeLoginStats (id) {
    return request(`${url}/${id}/login-stats`)
  },
  updateEmployeeLoginStats (id, values) {
    return request(`${url}/${id}/login-stats`, {
      method: 'PUT',
      headers,
      body: JSON.stringify(values)
    })
  },
  getEmployeePrevClient (id) {
    return request(`${url}/${id}/client/prev`)
  },
  listByPage (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  listByPageAddress (page, size, filter, sorting, text) {
    return request(`${url}/map/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  listByPageActive (page, size, filter, sorting, text) {
    return request(`${url}/page/${page}/size/${size}/active${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  listByPageNotification (page, size, filter, sorting, text) {
    return request(`${url}/notification/page/${page}/size/${size}${queryString.stringify({ filter: JSON.stringify(filter), sorting: JSON.stringify(sorting), text })}`)
  },
  getSuburbs () {
    return request(`${url}/suburbs`)
  },
  getEmployeeIds () {
    return request(`${url}/ids`)
  },
  sendJobReminder (id, from, to) {
    return request(`${url}/${id}/reminder/${from}/${to}`)
  },
  checkDuplicateEmployee (values) {
    return request(`${url}/check/duplicate${queryString.stringify(values)}`)
  }
}
